export default "/images/vendor/flag-icon-css/flags/1x1/af.svg?ecae91f83076777898e1408514a563e4";